// External Libraries
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Grid from 'screens/components/basic/Grid';
import CardSimple from 'screens/components/basic/CardSimple';
import Pagination from 'screens/components/basic/Pagination';
import LOOKUP from 'constants/lookup';
import Body from './Body';
import Header from './Header';
import moment from 'moment';
import { getEmployeeTimesheet, getCsvReport } from 'actions/ReportsAction';
import { getAllEmployees } from 'actions/EntityActions';
import { formInput, clearFormInput } from 'actions/FormActions';
import { reportEmployeeTimesheetCrumb } from 'utils/breadcrumbInfo';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import PageHeader from 'screens/components/basic/PageHeader';
import { showError } from 'actions/CommonActions';
import { checkDateRange } from 'utils/helpers';
import DateCurrentDisplay from 'screens/containers/report/DateCurrentDisplay';

class EmployeeTimesheet extends Component{
    constructor(props){
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage : 20,
            totalRow: 0,
            showBody: false,
            model: {
                year: 0,
                branch: 0
            }
        }
        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date()
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1),
        `EmployeeTimesheetBeginDate`)
        this.props.formInput(date, `EmployeeTimesheetEndDate`)
        this.props.getEmployees();
    }

    getEmployeeOptions = () => {
        var employeeOptions = (this.props.employees || []).map(item => {
                return {
                    text: `${item.firstName} ${item.lastName}`,
                    value: item.id.toString()
                };
            });
        return [{
            text: `All`,
            value: '0'
        } , ...employeeOptions];
    }

    getReport = () => {
        let startDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).add(1,'day').format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branchId = this.props.branch || this.props.loggedBranch;
        let employeeIds =this.props.employeeName || 0;
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;
        let status = parseInt(this.props.status,10) || 0;
        this.props.getEmployeeTimesheet({ startDate, endDate, branchId, employeeIds, status,pageNumber,pageSize});
    }

    downloadReport = () => {
        let startDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).add(1,'day').format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branchId = this.props.branch || this.props.loggedBranch;
        let employeeIds =this.props.employeeName || 0;
        let pageNumber = 1;
        let pageSize = 9999;
        let status = parseInt(this.props.status,10) || 0;
        
        if (checkDateRange(startDate,endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.props.getCsvReport(`reports/excel/shiftbyemployeedetails?employeeIds=${employeeIds}&branchId=${branchId}&status=${status}&startDate=${startDate}&endDate=${endDate}&pageNumber=${pageNumber}&pageSize=${pageSize}`, "EmployeeTimesheet");
        }
    }

    filter = () => {
        this.setState( pState => {
            return {
                ...pState,
                activePage: 1,
                showBody : false
            };
        }, this.getReport);
    }

    showBody(){
        if (checkDateRange(this.props.beginDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.filter();
            setTimeout(this.setState({showBody: true}), 1000) ;
        }
    }
    
    changePage = (e) => {
        this.setState( pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    render(){
        const totalRow = (this.props.employeeTimesheet && this.props.employeeTimesheet.length > 0) ? this.props.employeeTimesheet[0].totalrow : 0;

        return(
            <Grid headerContent={reportEmployeeTimesheetCrumb}>
                <PageHeader 
                    title={LOOKUP.report.employeeTimesheet.text} 
                    icon={<KnowledgeBase link="https://knowledge.techpos.ca/en/knowledge/timesheet" />}
                    description={LOOKUP.report.employeeTimesheet.description}
                />
                <Header 
                    branchOptions = {this.props.brachOptions}
                    employeeOptions={this.getEmployeeOptions()}
                    filter={this.filter}
                    showBody={this.showBody}
                    download={this.downloadReport}
                    />
                {
                    this.state.showBody && this.props.employeeTimesheet && 
                    <React.Fragment>
                        <DateCurrentDisplay />
                        <CardSimple>
                            <Body 
                                employees={this.props.employeeTimesheet} 
                                />
                            <Pagination
                                length={totalRow}
                                itemsPerPage={this.state.itemsPerPage}
                                activePage={this.state.activePage}
                                onPageChange={this.changePage}
                            />
                        </CardSimple>
                    </React.Fragment>
                }
            </Grid>
        );
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
             text: item.name, value: item.id.toString()
        });
    })
    return {
        brachOptions : brachOptions,
        employeeTimesheet: state.reports.employeeTimesheet,
        employees: state.entity.employeeList,
        loggedBranch: state.common.branchId,
        beginDate: state.form.EmployeeTimesheetBeginDate,
        endDate: state.form.EmployeeTimesheetEndDate,
        branch: state.form.EmployeeTimesheetBranchOption,
        employeeName: state.form.EmployeeTimesheetEmployeeName,
        status: state.form.EmployeeTimesheetStatus
    }
}

const mapDispatchToProps = dispatch => {
    return{
        getEmployeeTimesheet: model => dispatch(getEmployeeTimesheet(model)),
        getEmployees: () => dispatch(getAllEmployees()),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url,name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps) (EmployeeTimesheet);